//----------------------------
// create changed count entry
//----------------------------
export default function createChangedCountEntry({
  count_name = '', // count name
  id = null, // for character-count updates/deletes (character-count id) / will be temp-id for new count (tracking only)
  action = '', // 'ADD', 'UPDATE', 'DELETE'
  payload = {},
} = {}) {
  //--------------------------------------------------------------------------
  // basic validation - count_name and action are required for a valid change entry
  //--------------------------------------------------------------------------
  if (!count_name || !action) {
    throw new Error('Invalid input: count_name and action are required')
  }
  //--------------------------------------
  // extract payload fields with defaults
  //--------------------------------------
  const {
    character = null, // for new character_count (character id)
    name = '',
    value = 0,
  } = payload || {}
  //---------------------------------------------
  // resolve ids (explicit null if not provided)
  //---------------------------------------------
  const resolvedCharacterId = character ?? null
  //--------------------------------------------------------------------------
  // build output object progressively with clear intent for each action type
  //--------------------------------------------------------------------------
  const out = {
    count_name,
    action,
  }
  //---------------------------------------------------------------------
  // for ADD & UPDATE: include payload object describing editable fields
  //---------------------------------------------------------------------
  if (action === 'ADD' || action === 'UPDATE') {
    const outPayload = {
      name,
      value,
    }
    //---------------------------------------------------
    // for ADD: also include character id inside payload
    //---------------------------------------------------
    if (action === 'ADD') {
      outPayload.character = resolvedCharacterId
    }
    //-------------------------------------
    // assign constructed payload to output
    //--------------------------------------
    out.payload = outPayload
  }
  //-----------------------------------------------------------------------------------
  // UPDATE & DELETE: id = character-count id
  // ADD: id = temp id for tracking (actual character-id + static count-id provided inside payload for server-side creation)
  //-----------------------------------------------------------------------------------
  if (id != null) {
    out.id = id
  }
  //----------------
  // return results
  //----------------
  return out
}
